export const CHAT_ELEMENT_HEIGHT = 44;
export const AVATAR_HEIGHT = 31;
export const CHAT_ELEMENT_SPACING = 20;
export const SIDE_PADDING = 24;

export const FONT_FAMILY_LATIN = "'Inter', sans-serif";
export const FONT_FAMILY_HEB = "'Rubik', sans-serif";
